export default __webpack_public_path__ + "static/help_02_07-c47a9a779671a2a66401faf51d7003cd.png";